import type { DelegateTraceEntry } from '../../../data/projects/lib/computer-use-trace.types';

export type ComputerUsePlanPhase = 'awaiting' | 'running' | 'stopped' | 'done';

export const formatComputerUseElapsed = (totalSeconds: number): string => {
  const safe = Math.max(Math.floor(totalSeconds), 0);
  if (safe < 60) return `${safe}s`;
  const minutes = Math.floor(safe / 60);
  const seconds = safe % 60;
  return seconds === 0 ? `${minutes}m` : `${minutes}m ${seconds}s`;
};

// Drop lifecycle and success duplicates, but keep failures visible.
export const selectComputerUseActivityEntries = (
  trace: readonly DelegateTraceEntry[] | undefined
): DelegateTraceEntry[] =>
  (trace ?? []).filter(
    (entry) =>
      entry.isError ||
      entry.kind === 'tool_call' ||
      entry.kind === 'step_progress' ||
      entry.kind === 'planner_text' ||
      entry.kind === 'executor_text'
  );
